<template>
  <section class="user-invite-create">
    <v-card width="466" color="#FFFFFF" class="popup-box fullscreen-center">
      <button class="close-btn" @click="$emit('close-popup')">
        <icon-base color="#4A4A4A" width="16" height="16">
          <d-icon-close2 />
        </icon-base>
      </button>

      <div class="title-div">
        <d-icon-mapping-discard class="mb-2" />
        <div>
          <div class="popup-title mb-2">{{ $t("admin.discardChanges") }}</div>
          <div class="comfirmation-text" v-html="$t('admin.discardChangesMessage')"></div>
          <v-card-actions class="btn-div">
            <d-layout class="mt-4">
              <d-flex class="xs6 mr-2">
                <d-button
                  outline
                  depressed
                  round
                  block
                  class="body-2 no-text-transform"
                  color="#4689f4"
                  light
                  @click="$emit('close-popup')"
                  >{{ $t("all.no") }}</d-button
                >
              </d-flex>
              <d-flex class="xs6 ml-2">
                <d-button
                  depressed
                  round
                  block
                  class="body-2 white--text no-text-transform"
                  color="#4689F3"
                  light
                  @click="$emit('discard-changes')"
                  >{{ $t("admin.discardChangesBtn") }}</d-button
                >
              </d-flex>
            </d-layout>
          </v-card-actions>
        </div>
      </div>
    </v-card>

    <div class="popup-close" @click="$emit('close-popup')"></div>
  </section>
</template>

<script>
import IconBase from "@/components/IconBase.vue";
import DIconMappingDiscard from "@/components/icons/colored/DIconMappingDiscard.vue";
import DIconClose2 from "@/components/icons/DIconClose2.vue";

export default {
  name: "DDiscardMappingChangesConfirmation",
  props: {},
  components: {
    IconBase,
    DIconMappingDiscard,
    DIconClose2,
  },
};
</script>
<style scoped>
.user-invite-create {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.75);
}
.close-btn {
  position: absolute;
  right: 24px;
  top: 24px;
}
.fullscreen-center {
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.popup-box {
  position: relative;
  margin-top: 36px;
  padding: 48px 24px;
  margin: 0 auto;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.35);
}
.title-div {
  position: relative;
  width: 100%;
  text-align: center;
  padding: 42px 20px 0 20px;
}
.popup-title {
  color: #52545d;
  font-family: Roboto;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 28px;
  text-align: center;
  margin-top: 16px;
}
.comfirmation-text {
  color: #8d909f;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 30px;
  text-align: center;
}
.popup-close {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}
.no-text-transform {
  text-transform: none !important;
}
.btn-div {
  margin-top: 32px;
}
</style>
